module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems Configurator",
	"homepage.introtext": "Just answer a few questions below to configurate the GROHE Watersystem that will fit your needs.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "Do you have a cold and warm water supply in your kitchen?",
	"question1.option1.text": "I have cold and warm water supply in my kitchen",
	"question1.option2.text": "I have cold water supply only",
	"question2.question": "What type of water are you looking for?",
	"question2.option1.text": "Kettle hot water for preparing food and beverages",
	"question2.option2.text": "Chilled and sparkling water for drinking",
	"question2.option3.text": "Chilled and sparkling as well as kettle hot water",
	"question3.question": "Do you want to keep your existing kitchen tap?",
	"question3.option1.text": "I want to keep it.",
	"question3.option2.text": "I want to install a new model",
	"question4.question": "What should be your main tap?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "What's your prefered spout design?",
	"question5.option1.text": "L-shaped spout",
	"question5.option2.text": "U-shaped spout",
	"question5.option3.text": "C-shaped spout",
	"question6.question": "What's your preferred finish?",
	"question6.option1.text": "Chrome",
	"question6.option2.text": "Supersteel",
	"question7.question": "Which boiler size do you need?",
	"question7.option1.text": "M Size (3 Litres)",
	"question7.option2.text": "L Size (5.5 Litres)",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will also need:",
	"results.newConfiguration.title": "Do you want to configurate a new water system?",
	"results.newConfiguration.buttonText": "Configure a new water system",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product Information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.en_cy.json
// module id = 768
// module chunks = 0